import { teacherServiceURL } from '../../endpoint';

export function baseAIURL() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'ai/';
  return url;
}
